export default "__VITE_ASSET__DYs$wuF8__"